<template>
  <div class="form-item">
    <input type="text" v-model="inputValue" placeholder="Telefonszám" maxlength="12">
  </div>
</template>
<script>
import {miniFieldMixin} from '../../mixin/minifield'
export default {
  name: "Phone",
  mixins: [
    miniFieldMixin(function(value) {
      return value.length > 5
    })
  ],
}
</script>
